module.exports = __webpack_public_path__ + "img/t_8.f8076118.png";